(function () {
  class QuickViewModal extends ModalDialog {
    constructor() {
      super();
      this.dialogEl = this.querySelector('[role="dialog"]');
      this.panelEl = this.querySelector('.quick-view-panel');
      this.content = this.querySelector('#QuickViewInfo');
      this.originalSectionId = null;

      this.addEventListener('product-info:loaded', ({ target }) => {
        target.addPreProcessCallback(this.preprocess.bind(this));
      });
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading__spinner').classList.remove('hidden');
      opener.querySelector('.quickViewBtn__label')?.classList.add('opacity-0');

      this.content.innerHTML = '';
      this.originalSectionId = null;

      const productUrl = new URL(opener.dataset.productUrl, window.location.origin);
      productUrl.searchParams.set('quickview', '1');

      fetch(productUrl.toString())
        .then((res) => res.text())
        .then((responseText) => {
          const doc = new DOMParser().parseFromString(responseText, 'text/html');
          const productInfo = doc.querySelector('product-info');

          if (!productInfo) {
            throw new Error('No product-info found on the fetched page.');
          }

          this.originalSectionId = productInfo.dataset.section;
          this.preprocess(productInfo);

          HTMLUpdateUtility.setInnerHTML(this.content, productInfo.outerHTML);
          this.refreshYotpoWidgets();

          try {
            this.initSwymQuickViewButton(opener.dataset.productUrl);
          } catch (swymErr) {
            console.error('[Quick View Wishlist]', swymErr);
          }

          try {
            this.initKlaviyoBIS();
          } catch (bisErr) {
            console.error('[Quick View BIS]', bisErr);
          }

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          this.openDrawer(opener);
        })
        .catch((err) => {
          console.error('[Quick View]', err);

          this.content.innerHTML =
            '<p class="py-20 text-center text-gray-500">Sorry, we couldn\'t load this product.</p>';

          this.openDrawer(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading__spinner').classList.add('hidden');
          opener.querySelector('.quickViewBtn__label')?.classList.remove('opacity-0');
        });
    }

    openDrawer(opener) {
      const fullDetailsLink = this.querySelector('#QuickViewFullDetails');
      if (fullDetailsLink) fullDetailsLink.href = opener.dataset.productUrl;

      this.dialogEl.classList.remove('hidden');
      this.dialogEl.classList.add('flex');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.panelEl.classList.remove('translate-x-full');
        });
      });

      super.show(opener);
    }

    hide(preventFocus = false) {
      this.panelEl.classList.add('translate-x-full');

      if (preventFocus) this.openedBy = null;
      super.hide();

      setTimeout(() => {
        this.dialogEl.classList.add('hidden');
        this.dialogEl.classList.remove('flex');
        this.content.innerHTML = '';
        this.originalSectionId = null;
      }, 300);
    }

    preprocess(node) {
      node.querySelectorAll('modal-dialog:not([data-quickview-keep]), product-modal, pickup-availability').forEach((el) => el.remove());

      if (node.matches('product-info')) {
        node.setAttribute('data-update-url', 'false');
      }

      const sectionId = this.originalSectionId;
      if (!sectionId) return;

      const newId = `quickview-${sectionId}`;
      node.innerHTML = node.innerHTML.replaceAll(sectionId, newId);
      Array.from(node.attributes).forEach((attr) => {
        if (attr.value.includes(sectionId)) {
          node.setAttribute(attr.name, attr.value.replace(sectionId, newId));
        }
      });

      if (node.matches('product-info')) {
        node.dataset.originalSection = sectionId;
      }
    }

    refreshYotpoWidgets() {
      if (typeof yotpo !== 'undefined') {
        if (typeof yotpo.refreshWidgets === 'function') {
          yotpo.refreshWidgets();
        } else if (typeof yotpo.initWidgets === 'function') {
          yotpo.initWidgets();
        }
      } else if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      }
    }

    initSwymQuickViewButton(productUrl) {
      var container = this.content;
      var productInfoEl = container.querySelector('product-info');
      var productId = productInfoEl && productInfoEl.dataset.productId;

      if (!productId) return;

      var existingWrapper = container.querySelector('#swym-atw-button-container');
      var existingBtn = container.querySelector('[id^="swym-atw-pdp-button"]');
      var variantInput = container.querySelector('input[name="id"]');
      var variantId = variantInput ? variantInput.value : '';

      var fullProductUrl = productUrl
        ? new URL(productUrl, window.location.origin).toString()
        : window.location.href;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'swym-atw-quickview-button-' + productId;
      btn.className = 'swym-button swym-add-to-wishlist quickview-swym-btn';
      btn.setAttribute('aria-label', 'Add to Wishlist');
      btn.setAttribute('data-with-epi', 'true');
      btn.setAttribute('data-swaction', 'addToWishlist');
      btn.setAttribute('data-product-id', productId);
      btn.setAttribute('data-product-url', fullProductUrl);
      if (variantId) btn.setAttribute('data-variant-id', variantId);

      var existingIcon = container.querySelector('.swym-atw-pdp-button-img-icon, [id^="swym-atw-pdp-button-img-icon"]');
      if (existingIcon) {
        btn.appendChild(existingIcon.cloneNode(true));
      } else {
        btn.innerHTML = '<span class="quickview-swym-btn__icon" aria-hidden="true">&#9825;</span>';
      }

      if (existingWrapper && existingWrapper.parentNode) {
        existingWrapper.replaceWith(btn);
      } else if (existingBtn && existingBtn.parentNode) {
        existingBtn.replaceWith(btn);
      } else {
        return;
      }

      var buyAnchor =
        container.querySelector('.enquiry-form') ||
        container.querySelector('product-form') ||
        container.querySelector('.product-form__buttons') ||
        container.querySelector('form[action="/cart/add"]');

      if (buyAnchor) {
        var wrapper = document.createElement('div');
        wrapper.className = 'quickview-buy-wishlist-row';
        wrapper.style.display = 'flex';
        wrapper.style.alignItems = 'end';
        wrapper.style.gap = '10px';

        buyAnchor.parentNode.insertBefore(wrapper, buyAnchor);
        wrapper.appendChild(buyAnchor);
        wrapper.appendChild(btn);
      }

      var wire = function () {
        try {
          if (container.id) {
            window._swat.initializeActionButtons('#' + container.id);
          } else {
            window._swat.initializeActionButtons(container);
          }
        } catch (e) {
          console.error('[Quick View Wishlist] initializeActionButtons failed', e);
        }
      };

      if (productInfoEl) {

        var syncSwymVariant = function () {
          var input = productInfoEl.querySelector('input[name="id"]');
          if (!input || !input.value) return;

          btn.setAttribute('data-variant-id', input.value);

          if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
            wire();
          }
        };

        productInfoEl.addEventListener('change', function (event) {
          if (!event.target.matches('input[name="id"]')) return;
          syncSwymVariant();
        });

        btn.addEventListener('click', function () {
          var input = productInfoEl.querySelector('input[name="id"]');
          if (input && input.value) btn.setAttribute('data-variant-id', input.value);
        }, true);
      }

      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        wire();
      } else if (window.SwymCallbacks) {
        window.SwymCallbacks.push(wire);
      }
    }

    /**
     * Klaviyo Back in Stock for the quick view.
     *
     * When the selected variant is sold out, the quantity input and the
     * disabled "Sold out" button are hidden and a "Notify me" button is shown.
     * Clicking it opens the Klaviyo Back in Stock form.
     */
    initKlaviyoBIS() {
      const FORM_ID = (this.dataset.bisFormId || '').trim();
      const BUTTON_TEXT = this.dataset.bisButtonLabel || 'NOTIFY ME WHEN AVAILABLE';

      if (this.dataset.bisEnabled !== 'true' || !FORM_ID) return;

      const productInfoEl = this.content.querySelector('product-info');
      if (!productInfoEl) return;

      const dataEl = productInfoEl.querySelector('script[data-all-variants]');

      let variants = [];
      if (dataEl) {
        try {
          variants = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.error('[Quick View BIS] variants parse failed', e);
        }
      }

      const getVariant = () => {

        if (!variants.length) {
          const idInput = productInfoEl.querySelector('input[name="id"]');
          if (!idInput || !idInput.value) return null;
          const addBtn = productInfoEl.querySelector('.product-form__submit');
          return { id: Number(idInput.value), available: !(addBtn && addBtn.disabled) };
        }

        const selected = {};

        productInfoEl.querySelectorAll('variant-selects fieldset').forEach((fs) => {
          const checked = fs.querySelector('input:checked');
          const pos = fs.dataset.optionPosition;
          if (checked && pos) selected['option' + pos] = checked.value;
        });

        productInfoEl.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((dd) => {
          const sel = dd.querySelector('select.select__select');
          const pos = dd.dataset.optionPosition;
          if (sel && pos) selected['option' + pos] = sel.value;
        });

        const keys = Object.keys(selected);
        if (keys.length) {
          const match = variants.find((v) => keys.every((k) => v[k] === selected[k]));
          if (match) return match;
        }

        const input = productInfoEl.querySelector('input[name="id"]');
        const id = input ? Number(input.value) : null;
        return variants.find((v) => v.id === id) || null;
      };

      const apply = () => {
        const row = productInfoEl.querySelector('[id^="ProductBuyRow-"]');
        if (!row) return;

        const variant = getVariant();
        if (!variant) return;

        const qty = row.querySelector('quantity-input');
        const submit = row.querySelector('.product-form__submit');
        let box = row.querySelector('.qv-bis');

        if (!variant.available) {
          if (qty && qty.style.display !== 'none') {
            qty.style.setProperty('display', 'none', 'important');
          }
          if (submit && submit.style.display !== 'none') {
            submit.style.setProperty('display', 'none', 'important');
          }

          if (!box) {
            box = document.createElement('div');
            box.className = 'qv-bis';
            box.style.cssText = 'flex:1 1 100%;width:100%;';

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'qv-bis__btn button button--full-width button--primary';
            button.style.cssText = 'width:100%;min-height:40px;height:40px;';
            button.textContent = BUTTON_TEXT;

            box.appendChild(button);
            row.appendChild(box);
          }

          if (box.dataset.variantId !== String(variant.id)) {
            box.dataset.variantId = variant.id;
          }
        } else {
          if (box) box.remove();
          if (qty && qty.style.display === 'none') qty.style.removeProperty('display');
          if (submit && submit.style.display === 'none') submit.style.removeProperty('display');
        }
      };

      apply();

      productInfoEl.addEventListener('change', () => {
        apply();
        setTimeout(apply, 200);
      });

      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          apply();
        });
      }).observe(productInfoEl, { childList: true, subtree: true });

      productInfoEl.addEventListener('click', (e) => {
        const btn = e.target.closest('.qv-bis__btn');
        if (!btn) return;

        const box = btn.closest('.qv-bis');
        const variantId = Number(box.dataset.variantId);

        window.ShopifyAnalytics = window.ShopifyAnalytics || {};
        window.ShopifyAnalytics.meta = window.ShopifyAnalytics.meta || {};
        window.ShopifyAnalytics.meta.selectedVariantId = variantId;

        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', FORM_ID]);
      });
    }
  }

  if (!customElements.get('quick-view-modal')) {
    customElements.define('quick-view-modal', QuickViewModal);
  }

  document.addEventListener('click', function (event) {
    if (window.innerWidth > 749) return;

    if (event.target.closest('.quickViewBtn, .card__inquiry, modal-opener')) {
      return;
    }

    var stack = document.elementsFromPoint(event.clientX, event.clientY);
    var media = stack.find(function (el) {
      return el.classList && el.classList.contains('card__media');
    });

    if (media) {
      var card = media.closest('.card');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      var alreadyActive = card.classList.contains('mobile-actions-active');
      document.querySelectorAll('.card.mobile-actions-active').forEach(function (el) {
        el.classList.remove('mobile-actions-active');
      });
      if (!alreadyActive) {
        card.classList.add('mobile-actions-active');
      }
      return;
    }

    if (!event.target.closest('.card')) {
      document.querySelectorAll('.card.mobile-actions-active').forEach(function (el) {
        el.classList.remove('mobile-actions-active');
      });
    }
  });
})();